import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="bg-dark text-light py-4 mt-5">
      <Container>
        <Row className="text-center">
        <Col>
            <p className="mb-0">
              &copy; {new Date().getFullYear()} Circle of Care & Wellness. All rights reserved.
              <br />
              407 Unit #7 Gage Avenue Kitchener, Ontario N2M 5E1
            </p>          
        </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
